import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const BoxHover = styled(Box)`
  &:hover {
    box-shadow: 0 3px 16px 0 rgba(0, 0, 0, 0.11);
  }
`

export default BoxHover
